export default __webpack_public_path__ + "static/media/cta-request-playbook.554a3ac3.svg";